module.exports = "/_next/static/images/fi-079f4bcbd1f4a3a2ac55d1071961eaa4.svg";